import React from "react";

const ActionbarComponent = () => <div>ActionbarComponent</div>;

export default ActionbarComponent;
